// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".AppImage{max-width:100%;max-height:100%;width:auto;height:auto;vertical-align:middle;background:var(--modal-image-background-color)}.mr--lazyloading{filter:blur(2px)}", ""]);
// Exports
module.exports = exports;
